module.exports = __webpack_public_path__ + "static/media/Reporting14.a503c8d3.png";